<template>
    <div class="tab-content">
        <medical-form v-if="mountedTabs.medical" v-show="physician.MedicalTab"></medical-form>
        <details-form v-if="mountedTabs.details" v-show="physician.DetailsTabs"></details-form>
        <profile-form
            v-if="mountedTabs.profile"
            v-show="physician.ProfileTab"
            :patientDetails="patientDetails"
            @update-patientDetails="onPatientUpdate"
        ></profile-form>
        <summary-form v-if="mountedTabs.summary" v-show="physician.SummaryTab"></summary-form>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PhysicianMixin from 'mixins/PhysicianMixin'
    import MedicalForm from 'components/forms/medical/MedicalForm'
    import DetailsForm from 'components/forms/all-details/DetailsForm'
    import ProfileForm from 'components/forms/patient-profile/ProfileForm'
    import SummaryForm from 'components/forms/summary/SummaryForm'

    export default {
        mixins: [FormMixin, HandleRequestMixin, PhysicianMixin],
        components: {
            MedicalForm,
            DetailsForm,
            ProfileForm,
            SummaryForm,
        },
        props: {
            physician: { type: Object, required: true },
            patientDetails: { type: Object, required: true },
        },
        data() {
            return {
                mountedTabs: {
                    medical: false,
                    details: false,
                    profile: false,
                    summary: false,
                },
            }
        },
        methods: {
            onPatientUpdate() {
                this.emitEvent({ name: 'update-patient' })
            },
        },
        watch: {
            physician: {
                handler(val) {
                    if (val.MedicalTab) this.mountedTabs.medical = true
                    if (val.DetailsTabs) this.mountedTabs.details = true
                    if (val.ProfileTab) this.mountedTabs.profile = true
                    if (val.SummaryTab) this.mountedTabs.summary = true
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>
